e360.directive('dropdownResize', function () {
   return {
      restrict: 'A',
      link: function (scope, element, attrs) {
         var members = {},
            win = $(window);

         members.setMaxHeight = function () {
            element.css('max-height', win.height() - 100);
         };

         win.resize(members.setMaxHeight);
         members.setMaxHeight();

      }
   };
});
